import { HttpClient } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import {
  CreateTemporaryApproverRequestModel,
  OutOfOfficePeriod,
  PrimaryApproverOutOfOfficePeriod,
} from '@rx-applications/clientsite/temporary-approver/utils';
import { HttpService } from '@rx-applications/shared/utils';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class TemporaryApproverBackendService {
  #httpClient: HttpClient = inject(HttpClient);
  #httpService: HttpService = inject(HttpService);
  readonly #endpointDirectory = 'TemporaryApprover';

  getOutOfOfficePeriods$(): Observable<OutOfOfficePeriod[]> {
    return this.#httpClient.get<OutOfOfficePeriod[]>(`${this.#httpService.webApiUrl}${this.#endpointDirectory}/GetAll`);
  }

  gePrimaryApproverOutOfOfficePeriods$(): Observable<PrimaryApproverOutOfOfficePeriod[]> {
    return this.#httpClient.get<PrimaryApproverOutOfOfficePeriod[]>(
      `${this.#httpService.webApiUrl}${this.#endpointDirectory}/GetPrimaryApprovers`,
    );
  }

  deleteOutOfOfficePeriods$(outOfOfficePeriodId: string) {
    return this.#httpClient.delete(`${this.#httpService.webApiUrl}${this.#endpointDirectory}/${outOfOfficePeriodId}`);
  }

  createOutOfOfficePeriods$(requestModel: CreateTemporaryApproverRequestModel): Observable<string> {
    return this.#httpClient.post<string>(`${this.#httpService.webApiUrl}${this.#endpointDirectory}`, { ...requestModel });
  }
}
